import { useEffect } from "react";

import { useStore } from "../store.js";

/** A brief, self-dismissing message (e.g. why a connection was refused). */
export function Notice() {
  const notice = useStore((state) => state.notice);
  const setNotice = useStore((state) => state.setNotice);

  useEffect(() => {
    if (!notice) {
      return;
    }
    const timer = setTimeout(() => setNotice(null), 3500);
    return () => clearTimeout(timer);
  }, [notice, setNotice]);

  if (!notice) {
    return null;
  }

  return (
    <div className="pointer-events-none absolute left-1/2 top-4 z-30 -translate-x-1/2">
      <div className="pointer-events-auto rounded-lg border border-warning/40 bg-node-bg/95 px-4 py-2 text-sm text-ink shadow-xl backdrop-blur">
        {notice}
      </div>
    </div>
  );
}
